module.exports = __webpack_public_path__ + "img/AppHeader.b430536c.png";